import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { Dashboard } from './pages/Dashboard';
import { Doctors } from './pages/Doctors';
import { Medications } from './pages/Medications';
import { Exercise } from './pages/Exercise';
import { Statistics } from './pages/Statistics';
import { Appointments } from './pages/Appointments';
import { Journal } from './pages/Journal';
type Page = 'dashboard' | 'doctors' | 'appointments' | 'medications' | 'exercise' | 'journal' | 'statistics';
export function App() {
  const [activePage, setActivePage] = useState<Page>('dashboard');
  const renderPage = () => {
    switch (activePage) {
      case 'dashboard':
        return <Dashboard data-id="element-0" />;
      case 'doctors':
        return <Doctors data-id="element-1" />;
      case 'medications':
        return <Medications data-id="element-2" />;
      case 'exercise':
        return <Exercise data-id="element-3" />;
      case 'statistics':
        return <Statistics data-id="element-4" />;
      case 'appointments':
        return <Appointments data-id="element-5" />;
      case 'journal':
        return <Journal data-id="element-6" />;
      default:
        return <Dashboard data-id="element-7" />;
    }
  };
  return <div className="flex min-h-screen bg-slate-50 font-sans text-slate-900" data-id="element-8">
      <Sidebar activePage={activePage} onNavigate={setActivePage} data-id="element-9" />
      <main className="flex-1 ml-64 overflow-y-auto h-screen" data-id="element-10">
        {renderPage()}
      </main>
    </div>;
}